import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDS } from "../../utils/IDS";
import { DELETE, GET, POST } from "../../utils/Methods";
import { APIS } from "../../utils/APIS";
import Cookies from "js-cookie";
import { dashboard } from "../auth/Slice";


// GET Auth - Login
export const GetAllTurntableHistory = createAsyncThunk(
  "spin/GetAllTurntableHistory/get",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Spin.TurntableHistory}?page=${filter?.page || IDS.PAGE}`);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetTurntableDash = createAsyncThunk(
  "spin/GetTurntableDash/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Spin.Turntable);

      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const HitTurntableSpin = createAsyncThunk(
  "spin/HitTurntableSpin/post",
  async (_, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Spin.Turntable}`);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const Slice = createSlice({
  name: "spin",
  initialState: {
    data: [],
    dashboard: {},
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTurntableHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllTurntableHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllTurntableHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetTurntableDash.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetTurntableDash.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.dashboard = action.payload?.data || {};
      })
      .addCase(GetTurntableDash.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      ;
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
